import { render, staticRenderFns } from "./classLayout.vue?vue&type=template&id=4b9a7fd1&"
import script from "./classLayout.vue?vue&type=script&lang=js&"
export * from "./classLayout.vue?vue&type=script&lang=js&"
import style0 from "./classLayout.vue?vue&type=style&index=0&id=4b9a7fd1&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MaintenanceAlert: require('/builds/mytia/mege-educacional/components/MaintenanceAlert.vue').default,AppDropdownProfile: require('/builds/mytia/mege-educacional/components/AppDropdownProfile.vue').default,SurveyPopup: require('/builds/mytia/mege-educacional/components/SurveyPopup.vue').default})
